<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <app-login-form />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getStorage } from '../_helpers'

export default {
  name: 'Login',
  components: {
    AppLoginForm: () => import('../components/AppLoginForm')
  },
  data: () => ({ }),
  mounted () {
    let admin = getStorage('_admin')
    if (admin && admin.id && admin._token && admin.username) {
      this.$router.push({ path: '/' })
    }
  },
  methods: {}
}
</script>